import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import Layout from '~/components/layout/layouts/default';
import YrbsNavbar from '~/components/modules/sites/yrbs/navbar';

const LayoutYrbs = ({
	location,
	children,
	pageAnchors,
	jumbotron,
	...jumbotronProps
}) => {
	const data = useStaticQuery(graphql`
		query LayoutYrbsQuery {
			logo: file(
				name: {eq: "yrbs"},
				dir: {regex: "/yrbs/"}
			) {
				id
				base
				publicURL
				childImageSharp {
					gatsbyImageData(
						width: 193
					)
				}
			}
		}
	`);

	return (
		<Layout
			location={location}
			jumbotron={jumbotron}
			pageAnchors={pageAnchors}
			navbar={
				<YrbsNavbar
					location={location}
					toolkitLogo={
						<GatsbyImage
							image={data.logo.childImageSharp.gatsbyImageData}
							alt="YRBS"
							className="w-24"
						/>
					}
					toolkitUrl="/community-partners/toolkits/school-health-wellness/yrbs"
				/>
			}
			{...jumbotronProps}
		>
			{children}
		</Layout>
	);
};

export default LayoutYrbs;
